import React from "react";
import { Route, RouteComponentProps } from "react-router-dom";
import { RouteProps } from "react-router-dom";

interface RouteWrapperProps extends RouteProps {
    component?: React.FC<RouteComponentProps<any>>;
    layout: React.FC<{ children: React.ReactNode }>;
}

export function LayoutRoute({
    children,
    component: Component,
    layout: Layout,
    ...rest
}: RouteWrapperProps) {
    return (
        <Route
            {...rest}
            render={props => (
                <Layout {...props}>
                    {children}
                    {Component && <Component {...props} />}
                </Layout>
            )}
        />
    );
}
